<div class="card-content">
  <div class="content-icon">
    <fa-icon [icon]="icon()" />
  </div>
  <span class="label-large d-block mb-2">{{ mainTitle() }}</span>
  <p class="mb-3">{{ text() }}</p>
  <button
    lyceoButton
    [fill]="ButtonFill.OUTLINE"
    [status]="buttonStatus()"
    [block]="true"
    [disabled]="loading()"
    (click)="buttonClick.emit()"
  >
    {{ buttonText() }}
  </button>
</div>
@if (results().length) {
  <cdk-accordion class="card-results">
    <lyceo-accordion-item>
      <span class="label-large" header> Jouw resultaten </span>
      <div class="card-results-rows" content>
        @for (result of results(); track result.id) {
          <div class="card-results-row">
            <span>{{ result.finishedAt | lyceoDateFormat: 'd MMM y' }}</span>
            <span>{{ result.grade }}</span>
            <span
              >{{ result.questionsCorrect }}/{{ result.totalQuestions }}</span
            >
            <span class="view-result" (click)="viewResults.emit(result)"
              >Bekijk vragen</span
            >
          </div>
        }
      </div>
    </lyceo-accordion-item>
  </cdk-accordion>
}
